export const fontFamily = 'Barlow Semi Condensed'
export const fontWeight = 800
export const fontStyle = 'italic'
export const lineHeightScale = 0.9
export const shadowOffsetXScale = 0.0229
export const shadowOffsetYScale = 0.0328
